import { reactive } from "vue";

const CHECK_INTERVAL_MS = 5 * 60 * 1000;
const CURRENT_BUILD_ID = process.env.VUE_APP_BUILD_ID;

const state = reactive({
  updateAvailable: false,
});

let started = false;

async function checkForUpdate() {
  if (state.updateAvailable) {
    return;
  }

  try {
    const response = await fetch(`/version.json?_=${Date.now()}`, {
      cache: "no-store",
    });
    if (!response.ok) {
      return;
    }

    const { buildId } = await response.json();
    if (buildId && CURRENT_BUILD_ID && buildId !== CURRENT_BUILD_ID) {
      state.updateAvailable = true;
    }
  } catch {
    return;
  }
}

export function startVersionCheck() {
  if (started) {
    return;
  }
  started = true;

  setInterval(checkForUpdate, CHECK_INTERVAL_MS);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      checkForUpdate();
    }
  });
}

export function reloadToLatest() {
  window.location.reload();
}

export const versionCheckState = state;
